import React from 'react';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';

import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import PropTypes from "prop-types";

import '../Invoice/InvoiceToolBar.css';

export default function PurchaseTools(props) {
    return (
        <div className=" flex justify-content-around h-auto ml-1 g-1 flex-shrink-1 ">
            <Button icon="pi pi-plus" className="mr-1 invoice-tool-btn" onClick={()=>props.setAction("ADD")} disabled={props.invNumber === 0} />
            <Button icon="pi pi-print" className="mr-1 invoice-tool-btn" onClick={()=>props.setAction("PRINT")}  disabled={props.invNumber === 0}/>
            <Button icon="pi pi-trash" className="mr-1 invoice-tool-btn" onClick={()=>props.setAction("DELETE")} disabled={(props.invNumber === 0 || !props.enable|| props.customerId === 0)}/>
            <Button icon="pi pi-undo" className="mr-1 invoice-tool-btn" onClick={()=>props.setAction("UNDO")}/>
            <Button icon="pi pi-thumbs-up" className="mr-1 invoice-tool-btn" onClick={()=>props.setAction("POST")} disabled= {!props.enable||props.invNumber===0}/>
            <Button icon="pi pi-thumbs-down" className="mr-1 invoice-tool-btn" onClick={()=>props.setAction("UNPOST")} disabled={props.enable}/>
            <Button icon="pi pi-save" className="mr-1 invoice-tool-btn" onClick={()=>props.setAction("SAVE")} disabled={!props.enable || props.customerId===0}/>
        </div>
    )
}

PurchaseTools.propTypes = {
    setAction : PropTypes.func.isRequired,
    enable : PropTypes.bool.isRequired,
    invNumber : PropTypes.number.isRequired,
    customerId : PropTypes.number.isRequired,
}